<template>
  <div>
    <a-card class="l-container mt-4 mb-4">
      <a-button @click="visible = true"  preset="card"> Start Me up </a-button>
    </a-card>

    <Modal :visible="visible" @ok="visible = false" @cancel="visible = false">
      <div class="select-day container mx-auto">
        <a-row class="title">
          <a-col>
            <h1>宿泊日を指定</h1>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <div class="flex justify-start">
              <a-select style="min-width: 200px;">
                <a-select-option v-for="(el, i) in selectBox" :key="i" :value="el.value">
                  {{el.label}}
                </a-select-option>
              </a-select>
              <Stepper unit="泊" style="width: 120px;"/>
            </div>
          </a-col>
        </a-row>
        
        <div class="cm-calendar">
          <Calendar />
        </div>
        <div style="text-align: right">※１室あたりの料金です</div>
        <div style="text-align:center">
          <button class="c-btn btn-gray btn-cm">この条件で検索する（000件）</button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { Modal, Calendar, Stepper } from '@/components/primitive'

export default {
  components: {
    Modal,
    Calendar,
    Stepper
  },
  data() {
    return {
      visible: false,
      count: 0,
      current_date: null,
      days: [],
      the_day: [],
      index: 1,
      day_selected: 1,
      selectBox: [
        {
          label: 'スーペリアナチュラルツイン',
          value: 'スーペリアナチュラルツイン'
        }
      ]
    }
  },
  watch: {
    count() {
      this.index = this.index + 1
    }
  },
  methods: {
    Add() {
      const today = new Date()
      const tomorrow = new Date(today)
      const day = {
        key: 1,
        highlight: true,
        dates: tomorrow.setDate(tomorrow.getDate() + 0)
      }
      this.the_day.push(day)
      return this.the_day
    },
    Add_Day() {
      this.count++
      const today = new Date()
      const tomorrow = new Date(today)
      const day = {
        key: this.index,
        highlight: true,
        dates: tomorrow.setDate(tomorrow.getDate() + this.index)
      }
      this.the_day.push(day)
      return this.the_day
    },
    Remove_Day() {
      if(this.count > 0) {
        this.count--
        this.index = this.count
        this.the_day.pop()
      }
      return this.the_day
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>